import { useCallback } from 'react';
import {
	useFirstTimeMigratedUserFetchUserLazyQuery,
	useFirstTimeMigratedUserUpdateUserMutation,
} from './graphql.generated';

export const useMigratedUserIsLoggingInForTheFirstTime = () => {
	const [fetchUser] = useFirstTimeMigratedUserFetchUserLazyQuery();
	const [updateUser] = useFirstTimeMigratedUserUpdateUserMutation();

	const checkMigratedUserIsLoggingInForTheFirstTime = useCallback(async () => {
		let isMigrated = false;

		try {
			const result = await fetchUser();

			if (
				result.data?.currentUser?.id &&
				!result.data?.currentUser?.hasLoggedIn &&
				result.data?.currentUser?.migrationAccountUuid
			) {
				await updateUser({
					variables: { input: { id: result.data?.currentUser?.id, hasLoggedIn: true } },
				});
				isMigrated = true;
			}
		} catch (error) {
			console.error(error);
		}

		return { isMigrated };
	}, [fetchUser, updateUser]);

	return {
		checkMigratedUserIsLoggingInForTheFirstTime,
	};
};
